// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  baseUrl: "/api/",
  environmentName: 'production',
  scopeUri: ['api://d7a0797b-6e73-4f02-9c87-06d7c748006c/access_as_user'],  
  tenantId: '2c518df7-6644-41f8-8350-3f75e61362ac',  
  uiClienId: '19acabc5-8efa-450f-83fb-4bba411ca425',  
  apiClienId: 'd7a0797b-6e73-4f02-9c87-06d7c748006c',  
  redirectUrl: 'https://aurora.videojet.com/'
};

//App Name : VTI - PID Aurora Legal - Local

//App ID : a1010168-d7ea-4250-a96f-34e2b4bedfa9

//Object ID:f264f925-4204-4ae9-99e0-f6c25b2bb3be

//Tenant ID :771c9c47-7f24-44dc-958e-34f8713a8394

//Secret : OXj8Q~wAIhGYi__uaF918gxKbcTdt2JprQHbrcK4

//Expiry : 9/27/2023

  //"https://localhost:7099/",
  //baseUrl: "https://aurora-dev.videojet.com/api/",

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
